import script from "./AddressMixin.vue?vue&type=script&lang=js"
export * from "./AddressMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__